import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { RiMenu4Line, RiDashboardLine } from "react-icons/ri";
import { IoClose, IoGridOutline, IoHeartOutline } from "react-icons/io5";
import {
  MdOutlineCheckCircle,
  MdOutlinePayments,
  MdOutlineReportProblem,
} from "react-icons/md";
import { HiOutlineUsers, HiOutlineClipboardList } from "react-icons/hi";
import { BsClockHistory, BsHouseDoor, BsCash } from "react-icons/bs";
import { FaRegStickyNote } from "react-icons/fa";
import { SlEnergy } from "react-icons/sl";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const path = useLocation();

  const userData = JSON.parse(localStorage.getItem("yostelPG-userData"));
  const permissions = userData?.permissions || {};

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Define menu items with corresponding permissions
  const menuItems = [
    {
      label: "Dashboard",
      icon: <RiDashboardLine size={18} />,
      path: "/dashboard",
      permission: "dashboard",
    },
    {
      label: "Bookings",
      icon: <IoGridOutline size={18} />,
      path: "/bookings",
      permission: "bookings",
    },
    {
      label: "Check In",
      icon: <IoHeartOutline size={18} />,
      path: "/checkin",
      permission: "checkIn",
    },
    {
      label: "Check Out",
      icon: <MdOutlineCheckCircle size={18} />,
      path: "/check_outs",
      permission: "checkouts",
    },
    {
      label: "Resources",
      icon: <BsHouseDoor size={18} />,
      path: "/resources",
      permission: "resources",
    },
    {
      label: "Availability",
      icon: <BsClockHistory size={18} />,
      path: "/availability",
      permission: "availability",
    },
    // { label: "Inmates", icon: <HiOutlineUsers size={18} />, path: "/inmates_list", permission: "inmates" },
    {
      label: "Payments",
      icon: <BsCash size={18} />,
      path: "/payments_list",
      permission: "payments",
    },
    // { label: "Payment Approvals", icon: <MdOutlinePayments size={18} />, path: "/payments_approvals", permission: "paymentApprovals" },
    {
      label: "Issues",
      icon: <MdOutlineReportProblem size={18} />,
      path: "/issues",
      permission: "issues",
    },
    {
      label: "Notice",
      icon: <FaRegStickyNote size={18} />,
      path: "/notice",
      permission: "notice",
    },
    {
      label: "Expenses",
      icon: <HiOutlineClipboardList size={18} />,
      path: "/expenses",
      permission: "expenses",
    },
    {
      label: "Reports",
      icon: <IoGridOutline size={18} />,
      path: "/reports",
      permission: "reports",
    },
    {
      label: "Staff",
      icon: <HiOutlineUsers size={18} />,
      path: "/staff",
      permission: "staffs",
    },
    {
      label: "Electricity",
      icon: <SlEnergy size={18} />,
      path: "/electricity",
      permission: "electricity",
    },
  ];

  // Filter menu items based on permissions
  const filteredMenuItems = menuItems.filter(
    (item) => permissions[item.permission]
  );

  const renderMenuItems = () => (
    <ul className="space-y-1 tracking-wide ">
      {filteredMenuItems.map((item) => (
        <li key={item.path}>
          <div
            onClick={() => navigate(item.path)}
            className={`${
              path.pathname === item.path
                ? "bg-primaryColor text-white font-medium"
                : "text-primaryTextColor font-normal hover:bg-secondaryTextColor"
            } flex items-center cursor-pointer p-2 text-base rounded-lg mt-3`}
          >
            {item.icon}
            <span className="ml-3 tracking-wide">{item.label}</span>
          </div>
        </li>
      ))}
    </ul>
  );

  return (
    <React.Fragment>
      {/* Large sidebar */}
      <div className="lg:contents hidden flex-shrink-0" aria-label="Sidebar">
        <div className="overflow-y-auto pb-2 px-3 pt-6 bg-[#FFFFFF] shadow-2xl h-screen hide-scrollbar">
          {renderMenuItems()}
        </div>
      </div>

      {/* Mobile sidebar */}
      <div className="block lg:hidden">
        <button
          onClick={toggleSidebar}
          className="absolute ml-6 mt-[-50px] text-white"
        >
          {isSidebarOpen ? <IoClose size={30} /> : <RiMenu4Line size={30} />}
        </button>
        <AnimatePresence>
          {isSidebarOpen && (
            <motion.div
              className="h-full w-[50%] absolute z-50 shadow-2xl"
              initial={{ opacity: 0, x: "-100%" }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: "-100%" }}
              transition={{ duration: 0.3 }}
            >
              <div className="overflow-y-auto py-4 px-3 bg-[#FFFFFF] h-screen relative">
                {renderMenuItems()}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;

// import React from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { RiMenu4Line } from "react-icons/ri";
// import { IoClose } from "react-icons/io5";
// import {
//   Clock,
//   Grid,
//   Heart,
//   MessageSquare,
//   List,
//   FileText,
//   Home,
//   IndianRupee,
// } from "lucide-react";

// const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
//   const navigate = useNavigate();
//   const path = useLocation();

//   const userData = JSON.parse(localStorage.getItem("yostelPG-userData"));
//   const permissions = userData?.permissions || {};

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   // Define menu items with corresponding permissions
//   const menuItems = [
//     { label: "Dashboard", icon: <Clock />, path: "/dashboard", permission: "dashboard" },
//     { label: "Bookings", icon: <Grid />, path: "/bookings", permission: "bookings" },
//     { label: "Check In", icon: <Heart />, path: "/checkin", permission: "checkIn" },
//     { label: "Check Out", icon: <Heart />, path: "/check_outs", permission: "checkouts" },
//     { label: "Resources", icon: <Home />, path: "/resources", permission: "resources" },
//     { label: "Availability", icon: <MessageSquare />, path: "/availability", permission: "availability" },
//     { label: "Inmates", icon: <FileText />, path: "/inmates_list", permission: "inmates" },
//     { label: "Payments", icon: <IndianRupee />, path: "/payments_list", permission: "payments" },
//     { label: "Payment Approvals", icon: <IndianRupee />, path: "/payments_approvals", permission: "paymentApprovals" },
//     { label: "Issues", icon: <Heart />, path: "/issues", permission: "issues" },
//     { label: "Notice", icon: <Heart />, path: "/notice", permission: "notice" },
//     { label: "Expenses", icon: <Heart />, path: "/expenses", permission: "expenses" },
//     { label: "Reports", icon: <Heart />, path: "/reports", permission: "reports" },
//     { label: "Staff", icon: <List />, path: "/staff", permission: "staffs" },
//   ];

//   // Filter menu items based on permissions
//   const filteredMenuItems = menuItems.filter((item) => permissions[item.permission]);

//   const renderMenuItems = () => (
//     <ul className="space-y-1 tracking-wide">
//       {filteredMenuItems.map((item) => (
//         <li key={item.path}>
//           <div
//             onClick={() => navigate(item.path)}
//             className={`${path.pathname === item.path
//                 ? "bg-primaryColor text-white font-medium"
//                 : "text-primaryTextColor font-normal hover:bg-secondaryTextColor"
//               } flex items-center cursor-pointer p-2 text-base rounded-lg mt-3`}
//           >
//             {item.icon}
//             <span className="ml-3 tracking-wide">{item.label}</span>
//           </div>
//         </li>
//       ))}
//     </ul>
//   );

//   return (
//     <React.Fragment>
//       {/* Large sidebar */}
//       <div className="lg:contents hidden flex-shrink-0" aria-label="Sidebar">
//         <div className="overflow-y-auto pb-2 px-3 pt-6 bg-[#FFFFFF] shadow-2xl h-screen">
//           {renderMenuItems()}
//         </div>
//       </div>

//       {/* Mobile sidebar */}
//       <div className="block lg:hidden">
//         <button
//           onClick={toggleSidebar}
//           className="absolute ml-6 mt-[-50px] text-white"
//         >
//           {isSidebarOpen ? <IoClose size={30} /> : <RiMenu4Line size={30} />}
//         </button>
//         <AnimatePresence>
//           {isSidebarOpen && (
//             <motion.div
//               className="h-full w-[50%] absolute z-50 shadow-2xl"
//               initial={{ opacity: 0, x: "-100%" }}
//               animate={{ opacity: 1, x: 0 }}
//               exit={{ opacity: 0, x: "-100%" }}
//               transition={{ duration: 0.3 }}
//             >
//               <div className="overflow-y-auto py-4 px-3 bg-[#FFFFFF] h-screen relative">
//                 {renderMenuItems()}
//               </div>
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </div>
//     </React.Fragment>
//   );
// };

// export default Sidebar;
